class MmRecipes extends HTMLElement {
  /** @type {import('swiper').Swiper | null} */
  #swiper = null;

  connectedCallback() {
    this.#initSwiper();
  }

  disconnectedCallback() {
    this.#swiper?.destroy(true, true);
    this.#swiper = null;
  }

  #initSwiper() {
    if (typeof Swiper === 'undefined') return;

    const swiperEl = this.querySelector('.mm-recipes__swiper');
    const prevEl = this.querySelector('[data-mm-recipes-prev]');
    const nextEl = this.querySelector('[data-mm-recipes-next]');
    if (!swiperEl) return;

    this.#swiper = new Swiper(swiperEl, {
      slidesPerView: 'auto',
      spaceBetween: 16,
      grabCursor: true,
      watchOverflow: true,
      navigation: {
        prevEl,
        nextEl,
      },
      breakpoints: {
        750: {
          spaceBetween: 36,
        },
      },
      on: {
        init: () => this.#syncNav(),
        resize: () => this.#syncNav(),
        lock: () => this.#syncNav(),
        unlock: () => this.#syncNav(),
      },
    });

    this.#syncNav();
  }

  #syncNav() {
    const prevEl = this.querySelector('[data-mm-recipes-prev]');
    const nextEl = this.querySelector('[data-mm-recipes-next]');
    const show = !!(this.#swiper && !this.#swiper.isLocked && this.#swiper.slides.length > 1);

    if (prevEl) prevEl.hidden = !show;
    if (nextEl) nextEl.hidden = !show;
  }
}

if (!customElements.get('mm-recipes')) {
  customElements.define('mm-recipes', MmRecipes);
}
